const RETAILER_NUMBER_REGEXP = /^[0-9]{1,9}$/;

class RetailerNumberPatternDirective {
  constructor() {
    this.require = 'ngModel';
    this.restrict = 'A';
    this.link = (scope, elm, attrs, ctrl) => {
      ctrl.$validators.retailerNumberPattern = (modelValue, viewValue) => {
        // if (value === undefined || value === null) return true;

        if (ctrl.$isEmpty(modelValue)) {
          // consider empty models to be valid
          return true;
        }

        if (RETAILER_NUMBER_REGEXP.test(viewValue)) {
          // it is valid
          return true;
        }

        // it is invalid
        return false;
      };
    };
  }
}

export default RetailerNumberPatternDirective;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/retailer-number-pattern/retailer-number-pattern-directive.js